<svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 2.9999C10.9928 1.88899 7 1 1 3.83592V12.0012C1.05735 13.4454 2.5828 16.867 8.22581 18.9999C10.2903 18.2778 14.6946 15.8671 15.7957 12.0012V8.99992M5 8.99992L8.22581 12.0012L17 3.83592"
          stroke="white" stroke-width="2" stroke-linecap="round"/>
</svg>
